import styled from "@emotion/styled";

const Line = styled("div")`
  height: 0.1rem;
  width: 3.125rem;
  background-color: white;
  margin: 10px 0px;
`;

export default Line;
